import React from 'react';
import { Box, Grid, FormControlLabel, Checkbox } from '@material-ui/core';

import { CardDb } from '../redux/cardDbSlice';
import DrawToolContent, { DrawToolContentProps } from '../components/DrawToolContent';
import { deepCopy } from '../general';
import ColorPalette from '../components/ColorPalette';

type EditDrawCardProps = {
  card: CardDb;
  setCard: (card: CardDb) => void;
  drawToolContentProps: Omit<DrawToolContentProps, 'kind'>;
}
const EditDrawCard: React.FC<EditDrawCardProps> = ({card, setCard, drawToolContentProps}) => {
  const changeBackgroundDisplay = (display: boolean) => {
    const newCard = deepCopy(card);
    newCard.background.display = display;
    setCard(newCard);
    drawToolContentProps.setSetting({...drawToolContentProps.setting, 
      backgroundColor: display ? card.background.color : '#ffffff'}); 
  }
  const changeBackgroundColor = (color: string) => {
    const newCard = deepCopy(card);
    newCard.background.color = color;
    setCard(newCard);
    drawToolContentProps.setSetting({...drawToolContentProps.setting, backgroundColor: color}); 
  }
  const changeShadowDisplay = (display: boolean) => {
    const newCard = deepCopy(card);
    newCard.shadow = display;
    setCard(newCard);
  }
  const changeFrameDisplay = (display: boolean) => {
    const newCard = deepCopy(card);
    newCard.frame.display = display;
    setCard(newCard);
    drawToolContentProps.setSetting({...drawToolContentProps.setting, frameDisplay: display}); 
  }
  const changeFrameColor = (color: string) => {
    const newCard = deepCopy(card);
    newCard.frame.color = color;
    setCard(newCard);
    drawToolContentProps.setSetting({...drawToolContentProps.setting, frameColor: color}); 
  }


  return (
    <Box>
      <DrawToolContent kind="card" shadow={card.shadow} {...drawToolContentProps} />
      <Grid container alignItems="center" xs={12}>
        <Grid item alignItems="center" xs={12} md={4}>
          <Grid container alignItems="center">
            <FormControlLabel label="枠線表示"
              control={
                <Checkbox checked={card.frame.display} color="primary"
                  onChange={(ev) => changeFrameDisplay(ev.currentTarget.checked)} />
              } />
            <ColorPalette
              currentValue={card.frame.color}
              onChange={changeFrameColor}
              disabled={!card.frame.display}
            />
          </Grid>
        </Grid>
        <Grid item alignItems="center" xs={12} md={4}>
          <Grid container alignItems="center">
            <FormControlLabel label="背景表示"
              control={
                <Checkbox checked={card.background.display} color="primary"
                  onChange={(ev) => changeBackgroundDisplay(ev.currentTarget.checked)} />
              } />
            <ColorPalette
              currentValue={card.background.color}
              onChange={changeBackgroundColor}
              disabled={!card.background.display}
            />
          </Grid>
        </Grid>
        <Grid item alignItems="center" xs={12} md={4}>
              <FormControlLabel label="影あり"
                control={
                  <Checkbox checked={card.shadow} color="primary"
                    onChange={(ev) => changeShadowDisplay(ev.currentTarget.checked)} />
              } />
        </Grid>
      </Grid>
    </Box>
  );
}

export default EditDrawCard;
